import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ReportTask, ReportStatus} from './types';

interface ReportsState {
    tasks: ReportTask[];
}

const initialState: ReportsState = {
    tasks: [],
};

const reportsSlice = createSlice({
    name: 'reports',
    initialState,
    reducers: {

        addReportTask(state, action: PayloadAction<Omit<ReportTask, 'status'>>) {
            const {id, title, requestedAt, warnings} = action.payload;
            state.tasks.unshift({
                id,
                title,
                requestedAt,
                status: 'IN_PROGRESS',
                warnings: warnings ?? [],
            });
        },

        updateReportStatus(
            state,
            action: PayloadAction<{
                id: string;
                status: ReportStatus;
                warnings?: string[];
            }>,
        ) {
            const {id, status, warnings = []} = action.payload;
            const idx = state.tasks.findIndex((t) => t.id === id);
            if (idx !== -1) {
                state.tasks[idx].status = status;
                state.tasks[idx].warnings = warnings;
            }
        },
        removeReport(state, action: PayloadAction<string>) {
            state.tasks = state.tasks.filter((r) => r.id !== action.payload);
        },
    },
});

export const {addReportTask, updateReportStatus, removeReport} = reportsSlice.actions;
export default reportsSlice.reducer;
